<template>
  <div class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
    <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-white" />
  </div>
</template>
